import { css } from '@emotion/core';

export const textStyle = css`
  line-height: 24px;
`;
